import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTextFieldWithAddMore from '../../../FormFields/FormTextFieldWithAddMore';
import FormTitle from '../../../FormFields/FormTitle';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { PLANT_OPERATIONS } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

PhasesForm.propTypes = {
  permissions: PropTypes.object,
};

const fieldIds = [
  PLANT_OPERATIONS.PHASE_ONE_REPORTS.id,
  PLANT_OPERATIONS.PHASE_TWO_REPORTS.id,
  PLANT_OPERATIONS.FACILITY_FLOOR_PLAN.id,
  PLANT_OPERATIONS.WARRANTIED_EQUIPMENT.id,
  PLANT_OPERATIONS.HAS_VALVE_DIAGRAM.id,
];

export default function PhasesForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Phases
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {[
            PLANT_OPERATIONS.PHASE_ONE_REPORTS.id,
            PLANT_OPERATIONS.PHASE_TWO_REPORTS.id,
            PLANT_OPERATIONS.FACILITY_FLOOR_PLAN.id,
          ].some((id) => id in permissions) && (
            <>
              {PLANT_OPERATIONS.PHASE_ONE_REPORTS.id in permissions && (
                <Grid item xs={6}>
                  <FieldContainer>
                    <FormTitle fieldAttributes={{ questionTitle: 'Phase one reports', fieldType: 'file' }} />
                    <FormFileDrop
                      fieldName={PLANT_OPERATIONS.PHASE_ONE_REPORTS.fieldName}
                      fieldAttributes={{
                        isEditable: permissions[PLANT_OPERATIONS.PHASE_ONE_REPORTS.id],
                        fileTypeId: FILE_TYPES.PLANT_OPERATIONS_PHASE_ONE_REPORTS,
                      }}
                    />
                  </FieldContainer>
                </Grid>
              )}
              {PLANT_OPERATIONS.PHASE_TWO_REPORTS.id in permissions && (
                <Grid item xs={6}>
                  <FieldContainer>
                    <FormTitle fieldAttributes={{ questionTitle: 'Phase two reports', fieldType: 'file' }} />
                    <FormFileDrop
                      fieldName={PLANT_OPERATIONS.PHASE_TWO_REPORTS.fieldName}
                      fieldAttributes={{
                        isEditable: permissions[PLANT_OPERATIONS.PHASE_TWO_REPORTS.id],
                        fileTypeId: FILE_TYPES.PLANT_OPERATIONS_PHASE_TWO_REPORTS,
                      }}
                    />
                  </FieldContainer>
                </Grid>
              )}
              {PLANT_OPERATIONS.FACILITY_FLOOR_PLAN.id in permissions && (
                <Grid item xs={6}>
                  <FieldContainer>
                    <FormTitle fieldAttributes={{ questionTitle: 'Facility floor plan', fieldType: 'file' }} />
                    <FormFileDrop
                      fieldName={PLANT_OPERATIONS.FACILITY_FLOOR_PLAN.fieldName}
                      fieldAttributes={{
                        isEditable: permissions[PLANT_OPERATIONS.FACILITY_FLOOR_PLAN.id],
                        fileTypeId: FILE_TYPES.FLOOR_PLANS,
                      }}
                    />
                  </FieldContainer>
                </Grid>
              )}
              <Grid item xs={12}>
                <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
              </Grid>
            </>
          )}
          {PLANT_OPERATIONS.WARRANTIED_EQUIPMENT.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'List of equipment in facility under warranty' }} />
                <FormTextFieldWithAddMore
                  fieldName={PLANT_OPERATIONS.WARRANTIED_EQUIPMENT.fieldName}
                  isEditable={permissions[PLANT_OPERATIONS.WARRANTIED_EQUIPMENT.id]}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
              </Grid>
            </>
          )}
          {PLANT_OPERATIONS.HAS_VALVE_DIAGRAM.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Do you have a valve diagram in the facility?' }} />
                <FormButtonOptions
                  fieldName={PLANT_OPERATIONS.HAS_VALVE_DIAGRAM.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[PLANT_OPERATIONS.HAS_VALVE_DIAGRAM.id],
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                  }}
                />
              </FieldContainer>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
